import { RANDOM_COUNTRY_CODES } from './data/CountryCodes';
import { mapStringToIndex } from './random';

export function randomCountryCode(seed: string): string {
  const index = mapStringToIndex(seed, RANDOM_COUNTRY_CODES.length);
  return RANDOM_COUNTRY_CODES[index];

  // return pickRandomItem(RANDOM_COUNTRY_CODES);
}
